module.exports = __webpack_public_path__ + "static/Cost_cutting_on_Maintenance_Updates-3390a5621de68acfe5eb5478d91359f6.svg";